import { Component } from 'react';

class Footer extends Component {
  render() {
    return (
      <div className="col-lg-12">
        <div className="footer">
          Copyright © 2022 CARS24. All rights reserved.
        </div>
      </div>
    );
  }
}

export default Footer;

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
